import { Module } from "../lib/modules";
import { StateManager } from "../lib/stateManager";

export type ThemeType = "light" | "dark";

export interface ThemeState {
  theme: ThemeType;
}

export const Theme: Module<ThemeState> = () => {
  // Create a state manager with initial state
  const state = new StateManager<ThemeState>({
    theme: "light"
  });

  const applyTheme = (theme: ThemeType) => {
    document.documentElement.classList.remove("light-mode", "dark-mode");
    document.documentElement.classList.add(`${theme}-mode`);
    localStorage.setItem("theme", theme);
  };

  const loadSavedTheme = () => {
    const savedTheme = localStorage.getItem("theme") as ThemeType | null;

    if (savedTheme) {
      state.set("theme", savedTheme);
    } else {
      // If no saved theme, check system preference
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      state.set("theme", systemTheme);
    }
  };

  const init = () => {
    attachEventListeners();

    // Load saved theme or set system preference
    loadSavedTheme();
  };

  const attachEventListeners = () => {};

  const detachEventListeners = () => {};

  const destroy = () => {
    detachEventListeners();
  };

  // Set up theme change observers
  state.onChange("theme", (newTheme) => {
    applyTheme(newTheme);
  });

  return {
    init,
    attachEventListeners,
    detachEventListeners,
    destroy,
    state,
    pageBlacklist: ["/admin/*"],
    name: "theme"
  };
};
